import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import styles from './BindingPage.module.scss';
import toyotaLogo from '../../assets/TOYOTA LOGO - Horizontal.svg';
import statusFailSvg from '../../assets/status-fail.svg';

export default function Error({ message }) {
  const [searchParams] = useSearchParams();
  
  const errorMessage = message || 
                      searchParams.get('message') || 
                      '系統忙碌中，請稍後再試。';

  const handleBackToLineOA = () => {
    const lineOAUrl = process.env.REACT_APP_LINE_OA_URL;
    if (lineOAUrl) {
      window.location.href = lineOAUrl;
    }
  };

  return (
    <div className="center-viewport">
        <div className="toyota-header">
          <Link to="/">
            <img className="toyota-logo" src={toyotaLogo} alt="TOYOTA LOGO" style={{height: '20px', width: 'auto', display: 'block', margin: '0 auto', cursor: 'pointer'}} />
          </Link>
        </div>
          <div className={styles['center-card']}>
            <img src={statusFailSvg} alt="錯誤" className={styles['status-icon']} />
            <div className={styles['status-title']}>發生錯誤</div>
            <div className={styles['status-desc']}>{errorMessage}</div>
            <button 
              className={styles['status-btn'] + ' ' + styles['status-btn-red']}
              onClick={handleBackToLineOA}
            >
              回到LINE官方帳號
            </button>
          </div>
    </div>
  );
} 